import { LegacyIcon } from '@gonfalon/icons/LegacyIcon';
import type { LegacyIconProps } from '@gonfalon/icons/types';
import cx from 'clsx';

import AkamaiSvgColor from '../assets/akamai.svg';

export const AkamaiColor = ({ className, size, ...props }: LegacyIconProps) => (
  <LegacyIcon name="color-lang-akamai" className={cx('sdkIcon', className)} size={size} {...props}>
    <AkamaiSvgColor />
  </LegacyIcon>
);
